var map = {
	"./aristocrat.jpg": 40,
	"./caudrill_1.jpg": 41,
	"./caudrill_2.jpg": 42,
	"./caudrill_3.jpg": 43,
	"./hist-blackface.png": 38,
	"./hist-monkey.jpg": 39,
	"./murphy1.jpg": 44,
	"./murphy2.jpg": 45,
	"./murphy3.jpg": 46,
	"./murphy4.jpg": 47,
	"./panis_1.jpg": 101,
	"./panis_10.jpg": 102,
	"./panis_11.jpg": 103,
	"./panis_12.jpg": 104,
	"./panis_13.jpg": 105,
	"./panis_14.jpg": 106,
	"./panis_15.jpg": 107,
	"./panis_16.jpg": 108,
	"./panis_17.jpg": 109,
	"./panis_18.jpg": 110,
	"./panis_19.jpg": 111,
	"./panis_2.jpg": 112,
	"./panis_20.jpg": 113,
	"./panis_21.jpg": 114,
	"./panis_22.jpg": 115,
	"./panis_23.jpg": 116,
	"./panis_24.jpg": 117,
	"./panis_25.jpg": 118,
	"./panis_26.jpg": 119,
	"./panis_27.jpg": 120,
	"./panis_28.jpg": 121,
	"./panis_29.jpg": 122,
	"./panis_3.jpg": 123,
	"./panis_30.jpg": 124,
	"./panis_4.jpg": 125,
	"./panis_5.jpg": 126,
	"./panis_6.jpg": 127,
	"./panis_7.jpg": 128,
	"./panis_8.jpg": 129,
	"./panis_9.jpg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;